import { useCallback, useState } from 'react';
import EllaMicConsentDialog from '../components/EllaMicConsentDialog';
import { acceptEllaMicConsent, hasEllaMicConsent } from '../utils/ellaMicConsent';

export default function useEllaMicStart(onStart) {
  const [showConsent, setShowConsent] = useState(false);

  const requestStart = useCallback(() => {
    if (!hasEllaMicConsent()) {
      setShowConsent(true);
      return;
    }
    onStart();
  }, [onStart]);

  const allow = useCallback(async () => {
    await acceptEllaMicConsent();
    setShowConsent(false);
    onStart();
  }, [onStart]);

  const dialog = showConsent ? (
    <EllaMicConsentDialog onAllow={allow} onNotNow={() => setShowConsent(false)} />
  ) : null;

  return { requestStart, dialog };
}
